import { Button } from '@design-system/button';
import React, { FC } from 'react';

import { FilterGroupResetProps } from './models';

const FilterGroupReset: FC<FilterGroupResetProps> = ({
  handleGroupReset,
  activeGroup,
  clearSelectedFilters,
}) => (
  <div className="filter-group__reset">
    <Button
      variant="subtle"
      size="small"
      iconPrefix={{ props: { icon: 'close' } }}
      onClick={() => handleGroupReset(activeGroup)}
    >
      {clearSelectedFilters}
    </Button>
  </div>
);

export default FilterGroupReset;
